<section class="content-layout" *ngIf="!linkExpired">
  <bw-action-article-legacy [brightsideWebFb]="{ event_name: 'credit_smfa' }">

    <ui-nav-exit-back
      back-action-bottom
      [trackingDetail]="{ event_name: 'credit_smfa' }"
      (exitActionHandler)="routeUserOnBack()"
    ></ui-nav-exit-back>

    <div content-section>
      <div class="flex-column space-center mb-xl">
        <img src="../assets/texts.png"  class="mb-md" />
        <p title-medium class="mb-sm">{{ 'CREDIT_SMFA_TITLE' | translate }}</p>
        <typography-legacy text-large-regular color="var(--secondary-text)">
          <p class="center" style="max-width: 432px; white-space: pre-wrap">
            {{ 'CREDIT_SMFA_DESC' | translate: { time: smfaTimeTimeoutInMinutes } }}
          </p>
        </typography-legacy>
      </div>
    </div>

    <div footer-actions class="flex-column">
      <button
        bw-link-button-legacy
        [secondaryCta]="true"
        [brightsideWebFb]="{ event_name: 'credit_smfa' }"
        (click)="requestText()">
        {{ 'CREDIT_SMFA_CTA2' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>

<section class="content-layout" *ngIf="linkExpired">
  <bw-action-article-legacy [brightsideWebFb]="{ event_name: 'credit_smfa' }">

    <ui-nav-exit-back
      back-action-bottom
      [trackingDetail]="{ event_name: 'credit_smfa' }"
      (exitActionHandler)="routeUserOnBack()"
    ></ui-nav-exit-back>

    <div content-section>
      <div class="flex-column space-center mb-xl">
        <img src="../assets/texts_failed.png"  class="mb-md" />
        <p title-medium class="mb-sm">{{ 'CREDIT_SMFA_TIMEOUT_TITLE' | translate }}</p>
        <typography-legacy text-large-regular color="var(--secondary-text)">
          <p class="center" style="max-width: 432px; white-space: pre-wrap">
            {{ 'CREDIT_SMFA_TIMEOUT_DESC' | translate: { time: smfaTimeTimeoutInMinutes } }}
          </p>
        </typography-legacy>
      </div>
    </div>

    <div footer-actions class="flex-column">
      <button
        bw-button-legacy
        [brightsideWebFb]="{ event_name: 'credit_smfa' }"
        (click)="requestText()">
        {{ 'CREDIT_SMFA_TIMEOUT_CTA1' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>
